import type { CommonIconProps } from '@workramp/ui';
import { Icon } from '@workramp/ui';
import { APP_CONSTANTS } from '~/common/explicit-exports';

interface IntegrationProviderIconProps extends Omit<CommonIconProps, 'name'> {
  slug: string;
  fallback?: {
    src?: string;
    alt?: string;
    height?: number;
    width?: number;
  };
}

export function IntegrationProviderIcon({ slug, fallback, ...props }: IntegrationProviderIconProps) {
  switch (slug) {
    case APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.UDEMY:
      return <Icon name="udemy:brand" {...props} />;
    case APP_CONSTANTS.TOP_LEVEL_CONTENT_CONTENT_SOURCES.LINKEDIN_LEARNING:
      return <Icon name="linkedin:brand" {...props} />;
    case APP_CONSTANTS.NATIVE_HRIS_PROVIDERS.LATTICE:
      return <Icon name="lattice:brand" {...props} />;
    default:
      if (fallback?.src != null) {
        const { src, alt, height = 32, width = 32 } = fallback;
        return <img src={src} alt={alt} height={height} width={width} />;
      }
      return null;
  }
}
